import {
  BSP,
  DARSHAN,
  FMF_FM,
  FMF_M,
  ILMLODGES,
  ILM,
  ILMSTUDIOS,
  LBYANTRA,
  SANNIDHI,
  SAMYAMA
} from '../constants/programConstants'
import { roomTypes } from '../constants/roomConstants'

/**
 *
 * @param program
 * @returns {object} - Configuration for the program. Values described below:
 * useProgramAccommodation {boolean|string} - True or false or 'both' to allow either option
 */
export function getProgramDetails(program) {
  let checkInDate = '2018-10-29'
  let checkOutDate = '2018-10-30'

  const fmfConfig = {
    programName: 'Full Moon Flirtations',
    programDates: 'April 24 - 26',
    bannerText:
      'This page is ONLY for Full Moon Flirtations participants to book stay April 24 - 26',
    checkInMinDate: '2021-04-24',
    checkInMaxDate: '2021-04-24',
    checkOutMinDate: '2021-04-26',
    checkOutMaxDate: '2021-04-26',
    allowMultipleBookings: false,
    childrenAllowed: true,
    minAge: 7,
    minAdultAge: 14,
    useProgramAccommodation: 'both',
    roomType: [
      roomTypes.mahimaStay,
      roomTypes.lodge,
      roomTypes.studio,
      roomTypes.cabin
    ],
    minStudioGuests: 2,
    blocker: {
      firstName: 'FMF',
      lastName: 'Blocker'
    }
  }

  if (program === SANNIDHI) {
    return {
      programName: 'Sannidhi Yantra Ceremony',
      programDates: 'October 29th - October 30th',
      bannerText:
        'This page is ONLY for Sannidhi Yantra Ceremony participants to book Mahima stay Oct 29-30',
      checkInMinDate: checkInDate,
      checkInMaxDate: checkInDate,
      checkOutMinDate: checkOutDate,
      checkOutMaxDate: checkOutDate,
      allowMultipleBookings: true,
      checkOutTime: { hour: 11 }
    }
  } else if (program === LBYANTRA) {
    return {
      programName: 'Linga Bhairavi Yantra Ceremony',
      programDates: 'May 5th - 7th',
      bannerText:
        'This page is ONLY for Linga Bhairavi Yantra Ceremony participants to book studios May 5th - 7th',
      checkInMinDate: '2020-05-05',
      checkInMaxDate: '2020-05-06',
      checkOutMinDate: '2020-05-06',
      checkOutMaxDate: '2020-05-07',
      allowMultipleBookings: true,
      roomType: roomTypes.studio,
      blocker: {
        firstName: 'Yantra Ceremony',
        lastName: 'Studio Blocker'
      },
      useProgramAccommodation: false
    }
  } else if (program === BSP) {
    return {
      programName: 'Bhava Spandana Program',
      programDates: 'Oct 21-26 and Oct 30 - Nov 1',
      bannerText:
        'This page is ONLY for Bhava Spandana Program participants to book additional nights stay Oct 21-26 and Oct 30 - Nov 1',
      checkInMinDate: '2019-10-21',
      checkInMaxDate: '2019-10-31',
      checkOutMinDate: '2019-10-22',
      checkOutMaxDate: '2019-11-01',
      allowMultipleBookings: false
    }
  } else if (program === DARSHAN) {
    const checkInDate = '2020-01-04'
    const checkOutDate = '2020-01-05'
    return {
      programName: 'Darshan',
      programDates: 'Jan 4-5',
      bannerText:
        'This page is ONLY for Isha meditators to book mahima stay after Darshan from Jan 4th to 5th. Ages 11 and under are not permitted',
      checkInMinDate: checkInDate,
      checkInMaxDate: checkInDate,
      checkOutMinDate: checkOutDate,
      checkOutMaxDate: checkOutDate,
      allowMultipleBookings: true,
      minAge: 12
    }
  } else if (program === ILMSTUDIOS) {
    return {
      programName: 'In the Lap of the Master',
      programDates: 'May 2nd - 3rd',
      bannerText:
        'This page is ONLY for In the Lap of the Master participants to book additional nights stay April 29 - May 1 and May 4 - 5',
      checkInMinDate: '2020-04-29',
      checkInMaxDate: '2020-05-04',
      checkOutMinDate: '2020-04-30',
      checkOutMaxDate: '2020-05-05',
      allowMultipleBookings: false,
      childrenAllowed: false,
      minAdultAge: 15,
      roomType: roomTypes.studio,
      blocker: {
        firstName: 'ILM',
        lastName: 'Blocker'
      },
      useProgramAccommodation: false
      //freeDays: {
      //  min: '2020-05-01',
      //  max: '2020-05-04'
      //}
    }
  } else if (program === ILMLODGES) {
    return {
      programName: 'In the Lap of the Master',
      programDates: 'May 2nd - 3rd',
      bannerText:
        'This page is ONLY for In the Lap of the Master participants to book additional nights stay April 29 - May 1 and May 4 - 6',
      checkInMinDate: '2020-04-29',
      checkInMaxDate: '2020-05-05',
      checkOutMinDate: '2020-04-30',
      checkOutMaxDate: '2020-05-06',
      allowMultipleBookings: false,
      childrenAllowed: false,
      minAdultAge: 15,
      roomType: roomTypes.lodge,
      blocker: {
        firstName: 'ILM',
        lastName: 'Blocker'
      },
      useProgramAccommodation: false
    }
  } else if (program === ILM) {
    return {
      programName: 'In the Lap of the Master',
      programDates: 'Dec 27 - 29',
      bannerText:
        'This page is ONLY for In the Lap of the Master participants to book stay Dec 27 - 29',
      checkInMinDate: '2021-12-27',
      checkInMaxDate: '2021-12-27',
      checkOutMinDate: '2021-12-29',
      checkOutMaxDate: '2021-12-29',
      allowMultipleBookings: true,
      childrenAllowed: false,
      minAdultAge: 15,
      roomType: [roomTypes.studio, roomTypes.lodge, roomTypes.mahimaStay],
      blocker: {
        firstName: 'ILM',
        lastName: 'Blocker'
      },
      useProgramAccommodation: 'both',
      minStudioGuests: 2,
      checkInTime: { hour: 18, minute: 30 }
    }
  } else if (program === FMF_M) {
    return fmfConfig
  } else if (program === FMF_FM) {
    return {
      ...fmfConfig,
      roomType: [roomTypes.studio, roomTypes.cabin]
    }
  } else if (program === SAMYAMA) {
    return {
      programName: 'Samyama',
      programDates: 'April 17 - 26 and May 5 - 7',
      bannerText:
        'This page is ONLY for Samyama participants to book stay April 17-25 and May 5-7',
      checkInMinDate: '2023-04-17',
      checkInMaxDate: '2023-05-05',
      checkOutMinDate: '2023-04-26',
      checkOutMaxDate: '2023-05-07',
      allowMultipleBookings: false,
      childrenAllowed: false,
      minAdultAge: 18,
      roomType: [roomTypes.mahimaStay],
      useProgramAccommodation: true,
      validateProgramRegistration: true,
      programId: 4187
    }
  } else {
    return {}
  }
}

export function allowMultipleBookings(program, isAuthenticated) {
  return !program || isAuthenticated
    ? true
    : getProgramDetails(program).allowMultipleBookings
}



// WEBPACK FOOTER //
// ./src/logic/programBookingLogic.js